import React from 'react';
import * as FeatherIcon from 'react-feather';

const LoginFooter = () => {
  return (
    <footer className="custom_footer_login">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-lg-3 col-xl-3 custom_footer_block">
            <h5 className="custom_footer_head">Sales-related Queries:</h5>
          </div>

          <div className="col-md-3 col-lg-3 col-xl-3 custom_footer_block">
            <div className="phone_number">
              <div className="phone_icon_block">
                <FeatherIcon.Phone className="comp_icon" />
              </div>
              <div className="phone_text_block">
                <p className="phone_number">+1 (206) 401-8844</p>
                <p className="phone_text">(US Office HQ)</p>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-lg-3 col-xl-3 custom_footer_block">
            <div className="phone_number">
              <div className="phone_icon_block">
                <FeatherIcon.Phone className="comp_icon" />
              </div>
              <div className="phone_text_block">
                <p className="phone_number">+44 20 3869 5400</p>
                <p className="phone_text">(UK Office)</p>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-lg-3 col-xl-3 custom_footer_block">
            <div className="phone_number">
              <div className="phone_icon_block">
                <FeatherIcon.Mail className="comp_icon" />
              </div>
              <div className="phone_text_block">
                <p className="phone_number"><a href="mailto:sales@marketsandmarkets.com" className="mailto">sales@marketsandmarkets.com</a></p>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-lg-3 col-xl-3 custom_footer_block mt-4">
            <h5 className="custom_footer_head">Connect With Us</h5>
            <div className="row">
              <div className="col-md-2 col-lg-2 col-xl-2 custom_footer_block">
                <div className="phone_number">
                  <div className="phone_icon_block">
                    <a href="http://www.facebook.com/pages/Market-Research-Report/171919766173321" className="link_new" title="Follow us on Facebook" rel="nofollow noopener noreferrer" target="_blank"> <FeatherIcon.Facebook className='comp_icon' /></a>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-lg-2 col-xl-2 custom_footer_block">
                <div className="phone_number">
                  <div className="phone_icon_block">
                    <a href="http://twitter.com/marketsmarkets" rel="nofollow noopener noreferrer" className="link_new" target="_blank"><FeatherIcon.Twitter className='comp_icon' /></a>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-lg-2 col-xl-2 custom_footer_block ">
                <div className="phone_number">
                  <div className="phone_icon_block">
                    <a href="http://www.linkedin.com/company/marketsandmarkets" rel="nofollow noopener noreferrer" className="link_new" title="Check" target="_blank"><FeatherIcon.Linkedin className='comp_icon' /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-12 text-center footer-menu mt-4">
            <ul className="list-inline  custom-list d-flex justify-content-center mt-2">
              <li className="pr-2"> <a href="https://mnmks.com/pages/disclaimer" rel="nofollow noopener noreferrer" target="_blank">Disclaimer</a> </li>
              <li className="pr-2"> <a href="https://mnmks.com/homes/accessibility" rel="nofollow noopener noreferrer" target="_blank">Accessibility</a> </li>
              <li className="pr-2"> <a href="https://mnmks.com/pages/privacy" rel="nofollow noopener noreferrer" target="_blank">Privacy Policy</a> </li>
              <li className="pr-2"> <a href="https://mnmks.com/pages/terms_and_conditions" rel="nofollow noopener noreferrer" target="_blank">Terms and Conditions</a> </li>
            </ul>
            <p>| © 2014-2026 MarketsandMarkets Research Private Ltd. All Rights Reserved. |</p>
          </div>

          <div className="col-md-3 col-12 cards-payment mt-4">
            <h4 className="custom_footer_head">ABOUT TRUST ONLINE</h4>
            <ul className="list-inline d-flex">
              <li className="pr-2"> <span className=""><img src="/img/login/visa.webp" className="payment_icon" alt="payment icon"/> </span> </li>
              <li className="pr-2"> <span className=""><img src="/img/login/master_card.webp" className="payment_icon" alt="payment icon"/> </span> </li>
              <li className="pr-2"> <span className=""><img src="/img/login/american_express.webp" className="payment_icon" alt="payment icon"/> </span> </li>
              <li className="pr-2"> <span className=""><img src="/img/login/paypal.webp" className="payment_icon" alt="payment icon"/> </span> </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LoginFooter;
